import { generateHeaderPage } from '@/_legacy/services/checklist';
import { CHECKLIST_STATUS } from '@/_legacy/constants';
import { useTask } from '@/ui/concerns';
import { createChecklistFromTemplate } from '@/services/api/resources/template/actions';
import { toasted } from '@/ui/helpers';
import { v4 as uuidv4 } from 'uuid';
import { ref } from 'vue';

export function useTemplate() {
  const isLoading = ref(false);

  const createTemplateTask = (
    successCallback: Function | undefined,
    errorCallback: Function | undefined,
  ) => useTask(
    (body: FormData | undefined) => {
      isLoading.value = true;

      return createChecklistFromTemplate(body!);
    },
    () => {
      if (successCallback) {
        successCallback();
      }

      isLoading.value = false;
    },
    uuidv4(),
    error => {
      toasted.error(error.message);
      isLoading.value = false;

      if (errorCallback) {
        errorCallback();
      }
    },
  );

  const encodeTemplateIntoChecklist = (template: Record<string, unknown> = {}) => ({
    checklist_title: template.title || '',
    checklist_description: template.description || '',
    entity_items: template.entityItems || [],
    categories: template.categories || [],
    report_template: template.report_template || null,
    form: template.form || {},
    hasUserAutomatic: template.hasUserAutomatic || true,
    hasDatetimeAutomatic: template.hasDatetimeAutomatic || true,
    status: template.status || CHECKLIST_STATUS.ACTIVE,
    schedules: template.schedules || [],
    restrictions: template.restrictions || null,
  });

  const newChecklistFromTemplate = (
    template: Record<string, unknown>,
    successCallback: Function | undefined = undefined,
    errorCallback: Function | undefined = undefined,
  ) => {
    // Since we are dealing with legacy endpoint we need to encode into a form data
    // as soon as we refactor checklist feature we should refactor this as well
    const formData = new FormData();
    const encodedTemplate = encodeTemplateIntoChecklist(template);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const formItems = (encodedTemplate.form as any).items;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if (!formItems.some(((item: any) => item.params?.header === true))) {
      formItems.unshift(generateHeaderPage());
    }
    const payload = JSON.stringify(encodedTemplate);
    formData.append('checklist', payload);
    formData.append('fromTemplate', String(template.fromTemplate || 0));
    formData.append('fromAiPrompt', template.fromAiPrompt ? 'true' : 'false');
    formData.append('fromFileUpload', template.fromFileUpload ? 'true' : 'false');
    createTemplateTask(successCallback, errorCallback).run(formData);
  };

  return {
    isLoading,
    encodeTemplateIntoChecklist,
    newChecklistFromTemplate,
  };
}
